import _ from 'underscore';

import config from './../config.js';

export default {
	_getList() {
		try {
			return localStorage.getItem(config.localLibraryName) ? JSON.parse(localStorage.getItem(config.localLibraryName)) : [];
		}
		catch (e) {
			return [];
		}
	},

	_saveList(list) {
		try {
			localStorage.setItem(config.localLibraryName, JSON.stringify(list));
		}
		catch (e) {

		}
	},

	add(item) {
		var storageList = this._getList();

		item._date_added = (new Date()).toISOString();

		storageList.push(item);

		this._saveList(storageList);
	},

	remove(item) {
		var storageList = this._getList();

		storageList = _.reject(storageList, function(listItem) {
			if (typeof item == 'object') {
				return listItem.id == item.id;
			}
			else {
				return listItem.id == item;
			}
		});

		this._saveList(storageList);
	},

	find(item) {
		var storageList = this._getList();

		return _.findWhere(storageList, {
			id: item.id
		});
	},

	clear() {
		var storageList = this._getList();

		storageList = [];

		this._saveList(storageList);

		this.sendSignal();
	},

	list() {
		return this._getList();
	},

	registerSignal(func) {
		window._librarySignalListeners = window._librarySignalListeners || [];

		window._librarySignalListeners.push(func);
	},

	sendSignal() {
		if (window._librarySignalListeners) {
			window._librarySignalListeners.forEach(function(listener) {
				if (typeof listener == 'function') {
					listener();
				}
			})
		}
	}
};



// WEBPACK FOOTER //
// ./src/utils/localLibrary.js